import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';
import { Transition }               from '@uirouter/core';

import { UserService }          from '../users/user.service';
import { XeroCountryComponent } from './xero.country.component';
import { XeroSignupComponent }  from './xero.signup.component';

export const XeroStates : Array<NgHybridStateDeclaration> = [
  {
    component: XeroCountryComponent,
    name     : 'app.xero-country',
    resolve  : [
      {
        deps     : [ UserService ],
        resolveFn: ( userService : UserService ) => userService.getCountries(),
        token    : 'countries'
      }
    ],
    url: '/xero-country'
  },
  {
    component: XeroSignupComponent,
    name     : 'app.xero-signup',
    resolve  : [
      {
        deps     : [ Transition ],
        resolveFn: ( transitionService : Transition ) => transitionService.params().code,
        token    : 'code'
      },
      {
        deps     : [ UserService ],
        resolveFn: ( userService : UserService ) => userService.getCountries(),
        token    : 'countries'
      }
    ],
    url: '/xero-signup?code&country'
  }
];
